import _ from 'underscore';
import DEMAND_CLASSES from '../../modules/demand_classes.js';

angular.module('vastdesk').
  component('demandTagMultiCall',  {
    bindings: {
      formName: '@',
      formId: '@',
      multiCallEnabled: '<',
      multiCallMaximum: '<',
      readOnly: '<',
      accountMultiCallMax: '@',
      multiCallDisabledBidPlatforms: '<',
      bidPlatform: '@',
      demandClass: '@'
    },
    template: require("../templates/demandTagMultiCall.html"),
    controllerAs: '$demandTagMultiCallCtrl',
    controller: ['$rootScope', '$scope', function($rootScope, $scope) {

      var self = this;

      this.multiCallDisabled = function() {
        return disabledByDemandClass() ||
          disabledByBidPlatform();
      };

      var disabledByDemandClass = function() {
         return _.includes([DEMAND_CLASSES.CLASS_CREATIVE_ASSET, DEMAND_CLASSES.CLASS_HOUSE_AD, DEMAND_CLASSES.CLASS_LINE_ITEM], self.demandClass);
      };

      var disabledByBidPlatform = function() {
        return (self.demandClass === DEMAND_CLASSES.CLASS_HEADER_BIDDING) &&
          _.includes(self.multiCallDisabledBidPlatforms, self.bidPlatform);
      };

      var disableMultiCall = function() {
        if (self.multiCallDisabled()) {
          self.multiCallEnabled = false;
        }
      };

      $rootScope.$on('bidPlatformChange', function(e, args) {
        self.bidPlatform = args.bidPlatform;
        disableMultiCall();
      });

      $scope.$on('demandClassChanged', function(e, args) {
        self.demandClass = args.demandClass;
        disableMultiCall();
      });

      this.$onInit = function() {
        disableMultiCall();
      };

    }]
});
